<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header privacy-header">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="$router.back()">
            <ion-icon :icon="arrowBackOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>Политика конфиденциальности</ion-title>
        <ion-buttons slot="end">
          <HeaderMessengerButton />
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background privacy-content" :fullscreen="true">
      <div class="privacy-body ion-padding">
        <p class="privacy-intro">
          Настоящая Политика конфиденциальности (далее — Политика) определяет порядок обработки персональных данных
          пользователей мобильного и веб-приложения «Лига тренеров» / Liga.Team (далее — Приложение), включая сервис
          внутренней переписки Liga.Chat, и действует в отношении всех данных, которые Оператор может получить о
          пользователе при использовании Приложения.
        </p>
        <p class="privacy-meta">Редакция от 07.08.2026</p>

        <h2>1. Оператор персональных данных</h2>
        <p>
          Оператором персональных данных является Национальная лига тренеров (далее — Оператор).
          По вопросам обработки персональных данных пользователь может обратиться по адресу электронной почты:
          <a :href="'mailto:' + contactEmail" class="privacy-link">{{ contactEmail }}</a>.
        </p>
        <p>
          Обработка персональных данных осуществляется в соответствии с Конституцией РФ, Федеральным законом
          от 27.07.2006 №&nbsp;152-ФЗ «О персональных данных», иными нормативными актами РФ, а также настоящей Политикой.
        </p>

        <h2>2. Общие положения</h2>
        <p>
          Использование Приложения означает согласие пользователя с настоящей Политикой и условиями обработки
          персональных данных в объёме, необходимом для работы функций, которыми пользователь фактически пользуется.
          В случае несогласия с условиями пользователь должен воздержаться от использования Приложения либо отдельных
          функций (в том числе Liga.Chat).
        </p>
        <p>
          Оператор обеспечивает конфиденциальность персональных данных и принимает необходимые правовые,
          организационные и технические меры для их защиты.
        </p>

        <h2>3. Правовые основания обработки</h2>
        <p>Оператор обрабатывает персональные данные на следующих основаниях (ст.&nbsp;6 Федерального закона №&nbsp;152-ФЗ):</p>
        <ul>
          <li>согласие субъекта персональных данных;</li>
          <li>
            необходимость исполнения договора, стороной которого является пользователь (в том числе публичной оферты
            и оказываемых через Приложение услуг);
          </li>
          <li>
            необходимость исполнения обязанностей Оператора, установленных законодательством РФ;
          </li>
          <li>
            в случаях, прямо предусмотренных законом — для осуществления прав и законных интересов Оператора
            либо третьих лиц при условии, что не нарушаются права и свободы субъекта персональных данных.
          </li>
        </ul>

        <h2>4. Категории обрабатываемых данных</h2>
        <p>В зависимости от используемых функций Приложение может собирать и обрабатывать:</p>
        <ul>
          <li>
            <strong>данные учётной записи:</strong> имя, фамилия, адрес электронной почты, номер телефона, логин,
            сведения об аутентификации (пароль хранится в хешированном виде);
          </li>
          <li>
            <strong>данные об использовании сервисов:</strong> сведения о разделах Приложения (обучение, тестирование,
            тренировки, музыкальная библиотека, подписки, мероприятия и др.), прогресс, покупки и регистрации;
          </li>
          <li>
            <strong>данные Liga.Chat:</strong> содержимое сообщений (текст и/или зашифрованный шифротекст), вложения
            (например, изображения), реакции, сведения об участниках чатов и ролях, запросах на переписку, настройках
            приватности, блокировках, жалобах, статусах прочтения, служебных событиях чата, канале «Уведомления»
            и переписке с поддержкой;
          </li>
          <li>
            <strong>технические данные:</strong> тип и версия ОС, версия Приложения, идентификаторы устройства/сессии,
            push-токены (Firebase / Huawei и аналогичные сервисы доставки уведомлений), IP-адрес и журналы запросов
            в объёме, необходимом для работоспособности и безопасности;
          </li>
          <li>
            <strong>платёжные сведения</strong> в объёме, необходимом для оказания платных услуг (обработка платежей
            осуществляется платёжным провайдером; Оператор получает сведения о статусе оплаты и связанных заказах).
          </li>
        </ul>
        <p>
          Номер телефона может запрашиваться при оформлении платных подписок и регистрации на платные мероприятия —
          для связи по вопросам оплаты и оказания услуг.
        </p>
        <p>
          Оператор не осуществляет намеренную обработку специальных категорий персональных данных
          (ст.&nbsp;10 Федерального закона №&nbsp;152-ФЗ), за исключением случаев, когда пользователь самостоятельно
          сообщил такие сведения в переписке или профиле.
        </p>

        <h2>5. Цели обработки</h2>
        <p>Персональные данные используются для:</p>
        <ul>
          <li>предоставления доступа к материалам и услугам Приложения, идентификации пользователя;</li>
          <li>связи с пользователем (в том числе по телефону, e-mail и через Liga.Chat / поддержку);</li>
          <li>оформления и исполнения платных подписок, мероприятий и иных услуг;</li>
          <li>
            обеспечения работы Liga.Chat: доставка сообщений, групповые и публичные чаты, запросы на переписку,
            уведомления, модерация (в том числе фильтр нецензурной лексики в незашифрованном контенте),
            рассмотрение жалоб и обеспечение безопасности;
          </li>
          <li>отправки сервисных и информационных уведомлений (включая push и канал «Уведомления»);</li>
          <li>улучшения работы Приложения, предотвращения злоупотреблений и защиты прав Оператора и пользователей;</li>
          <li>исполнения требований законодательства РФ и договора оферты.</li>
        </ul>

        <h2>6. Liga.Chat</h2>
        <p>
          Liga.Chat — встроенный сервис обмена сообщениями между пользователями Приложения, а также канал связи
          с поддержкой и системных уведомлений Оператора.
        </p>
        <h3>6.1. Настройки приватности</h3>
        <p>
          Пользователь может управлять видимостью в поиске, политикой личных сообщений, отображением статуса
          «был(а) недавно» и возможностью добавлять его в группы. По умолчанию профиль в Liga.Chat настроен
          максимально приватно; пользователь может изменить настройки в разделе приватности мессенджера.
        </p>
        <h3>6.2. Шифрование и доступность содержимого</h3>
        <p>
          Для личных, групповых и публичных чатов Приложение поддерживает клиентское шифрование содержимого сообщений
          (режим E2E): открытый текст таких сообщений на стороне сервера, как правило, не хранится, хранится
          шифротекст. Ключи расшифровки хранятся на устройствах участников; на сервере могут храниться обёрнутые
          (зашифрованные) ключи чата для синхронизации между устройствами пользователя.
        </p>
        <p>
          Сообщения в чате поддержки и в системном канале «Уведомления», а также служебные события и незашифрованный
          контент (в том числе при недоступности режима E2E) обрабатываются Оператором в открытом виде в объёме,
          необходимом для оказания услуги, модерации и информирования.
        </p>
        <p>
          Вложения (например, изображения) и метаданные сообщений (участники, время отправки, статусы прочтения,
          реакции и т.п.) могут обрабатываться на сервере Оператора для доставки и отображения переписки.
        </p>
        <h3>6.3. Модерация и жалобы</h3>
        <p>
          Оператор вправе применять фильтры к незашифрованному контенту, рассматривать жалобы пользователей,
          ограничивать доступ к Liga.Chat (блокировка) и принимать иные меры для соблюдения правил сообщества
          и требований законодательства РФ.
        </p>
        <h3>6.4. Удаление чатов и сообщений</h3>
        <p>
          Пользователь может удалять отдельные сообщения и чаты в пределах предоставленных функций
          («только у себя» / «у всех» — в зависимости от типа чата и роли). Системный канал «Уведомления»,
          чат поддержки и чаты с принудительным участием удалению из ленты пользователем не подлежат.
          Удаление аккаунта регулируется разделом&nbsp;11 настоящей Политики и страницей
          <router-link to="/account-deletion" class="privacy-link">Удаление аккаунта</router-link>.
        </p>

        <h2>7. Передача третьим лицам и поручение обработки</h2>
        <p>
          Оператор не продаёт персональные данные. Передача или поручение обработки допускается:
        </p>
        <ul>
          <li>платёжным провайдерам — для проведения оплаты;</li>
          <li>
            провайдерам push-уведомлений и инфраструктурным сервисам (хостинг, доставка уведомлений) —
            в объёме, необходимом для работы Приложения;
          </li>
          <li>по требованию уполномоченных государственных органов в случаях, предусмотренных законодательством РФ;</li>
          <li>иным лицам — с согласия пользователя либо при наличии иного законного основания.</li>
        </ul>
        <p>
          При привлечении лиц, осуществляющих обработку по поручению Оператора, Оператор обеспечивает соблюдение
          требований Федерального закона №&nbsp;152-ФЗ к таким поручениям.
        </p>

        <h2>8. Место обработки и трансграничная передача</h2>
        <p>
          Оператор стремится осуществлять обработку и хранение персональных данных на территории Российской Федерации
          в соответствии с требованиями законодательства РФ.
        </p>
        <p>
          Отдельные технические операции (в частности, доставка push-уведомлений через зарубежных провайдеров)
          могут сопровождаться передачей технических идентификаторов за пределы РФ. Используя Приложение и разрешая
          уведомления, пользователь выражает согласие на такую передачу в объёме, необходимом для работы функции.
        </p>

        <h2>9. Сроки хранения</h2>
        <p>
          Персональные данные обрабатываются не дольше, чем этого требуют цели обработки, если иной срок не установлен
          законодательством РФ или договором. После достижения целей либо отзыва согласия данные подлежат уничтожению
          или обезличиванию, за исключением случаев, когда сохранение необходимо по закону
          (например, сведения о расчётах — в сроки, установленные бухгалтерским и налоговым законодательством РФ).
        </p>
        <p>
          Данные переписки Liga.Chat хранятся в течение срока существования чата/аккаунта и удаляются или
          обезличиваются при удалении соответствующих объектов либо аккаунта пользователя, с учётом технических
          ограничений резервного копирования и законных сроков хранения.
        </p>

        <h2>10. Меры защиты</h2>
        <p>
          Оператор принимает меры, направленные на предотвращение несанкционированного доступа, уничтожения,
          изменения, блокирования, копирования и распространения персональных данных, включая разграничение доступа,
          защищённую передачу данных (TLS), контроль учётных записей и иные организационные и технические меры.
        </p>

        <h2>11. Права пользователя</h2>
        <p>Пользователь (субъект персональных данных) вправе:</p>
        <ul>
          <li>получать сведения об обработке своих персональных данных;</li>
          <li>требовать уточнения, блокирования или уничтожения данных при наличии оснований, предусмотренных законом;</li>
          <li>отозвать согласие на обработку персональных данных;</li>
          <li>обжаловать действия или бездействие Оператора в Роскомнадзор или в суд.</li>
        </ul>
        <p>
          Для реализации прав направьте обращение на
          <a :href="'mailto:' + contactEmail" class="privacy-link">{{ contactEmail }}</a>
          либо воспользуйтесь функциями Приложения (настройки профиля, Liga.Chat, удаление аккаунта).
        </p>
        <p>
          Порядок удаления аккаунта и связанных данных описан на странице
          <router-link to="/account-deletion" class="privacy-link">Удаление аккаунта</router-link>.
        </p>
        <p>
          Отзыв согласия не влияет на законность обработки, осуществлённой до отзыва, и может сделать невозможным
          дальнейшее использование Приложения или отдельных функций.
        </p>

        <h2>12. Договор оферты</h2>
        <p>
          Использование Приложения и оказание услуг регулируются также условиями публичной оферты:
        </p>
        <a :href="offerUrl" target="_blank" rel="noopener noreferrer" class="privacy-link">{{ offerUrl }}</a>
        <p>Дополнение к оферте (платные события) доступно в Приложении:</p>
        <router-link to="/offer-supplement" class="privacy-link">Дополнение к оферте — платные события</router-link>

        <h2>13. Изменения Политики</h2>
        <p>
          Оператор вправе вносить изменения в настоящую Политику. Актуальная версия всегда доступна в Приложении.
          При существенных изменениях Оператор может повторно запросить подтверждение согласия в интерфейсе Приложения.
          Продолжение использования Приложения после публикации изменений означает принятие обновлённой Политики,
          если иное не требуется законодательством РФ.
        </p>

        <p class="privacy-footer">
          © Национальная лига тренеров<br />
          Контакт по персональным данным:
          <a :href="'mailto:' + contactEmail" class="privacy-link">{{ contactEmail }}</a>
        </p>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/vue';
import { arrowBackOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import { LEGAL } from '@/config/legal';

import HeaderMessengerButton from '@/components/HeaderMessengerButton.vue';

export default defineComponent({
  name: 'PrivacyPolicy',
  components: {
    HeaderMessengerButton,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonPage,
    IonTitle,
    IonToolbar,
  },
  setup() {
    return {
      arrowBackOutline,
      offerUrl: LEGAL.offerUrl,
      contactEmail: LEGAL.payee.email,
    };
  },
});
</script>

<style scoped>
.privacy-header {
  background: transparent;
  box-shadow: none;
}
.privacy-header ion-toolbar {
  --background: transparent;
  --color: var(--liga-chrome-text);
}
.privacy-link {
  display: inline;
}
a.privacy-link,
router-link.privacy-link {
  display: inline-block;
  margin: 0.15em 0;
}
</style>
